import script from "./HelpLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpLogin.vue?vue&type=script&setup=true&lang=ts"

import "./HelpLogin.vue?vue&type=style&index=0&id=6b9e0ef6&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9e0ef6"]])

export default __exports__